// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"b8334669","845":"8bde8a64","938":"fabccc4f"}[chunkId] + ".chunk.js";
};